export const ACCOUNT_PATH = "/account";
export const ACCOUNT_LOGIN_PATH = "/account/login";
export const ACCOUNT_SIGNUP_PATH = "/account/signup";

export const HOME_PATH = "/";
export const CONTRACTS_PATH = "/contracts";
export const CONTRACTS_DETAIL_PATH = "/contracts/:id";
export const CONTRACT_PAYMENTS_PATH = "/contracts/:id/payments";
export const CONTRACT_INVOICES_PATH = "/contracts/:id/invoices";
export const CONTRACT_INVOICES_INVOICE_DETAILS_PATH = "/contracts/:id/invoices/:date";
export const CONTRACT_ADHOC_INVOICES_PATH = "/contracts/:id/adhocs";

export const REPORTS_PATH = "/reports";

export const NODES_PATH = "/nodes";
export const NODE_DETAILS_PATH = "/nodes/:nodeUuid";
export const NODE_USER_DETAILS_PATH = "/nodes/:nodeUuid/users/:userUuid";
export const NODE_LINK_USERS_PATH = "/nodes/link-users/:linkNodeUuid";
export const NODES_BLUE_PENGUIN_PATH = "/bluepenguin";
export const NODES_BLUE_PENGUIN_UNASSIGNED_PATH = "/bluepenguin/unassigned";

export const USERS_PATH = "/users";
export const USER_PATH = "/users/:id";
export const USER_ACCOUNT_PATH = "/users/:id/account";
export const USER_ACCOUNT_UPDATE_PATH = "/users/:id/update-account";
export const USER_SERVICE_CHARGES_PATH = "/users/:id/service-charges";
export const USER_SERVICE_CHARGES_INVOICES_PATH = "/users/:id/service-charges/invoices";
export const USER_SERVICE_CHARGES_PAYMENTS_PATH = "/users/:id/service-charges/payments";

export const CHATS_PATH = "/chats";
